import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import moment from "moment"

import { Table } from "../../../helpers";
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';

import "./index.css"

import Loading from '../../../common/Loading';
import PMUserName from '../../../common/PMUserName';
import ButtonGroup from '../../../common/ButtonGroup';

import BuyerPoModal from './Components/BuyerPoModal';
import QuotationModal from './Components/QuotationModal';
import SearchBar from './Components/Search';

import { raiseToast } from '../../../services/redux/reducers/toast/toast';

import { getCompanyShortName } from '../../../utils'
import { fetchBuyerDashboardRequirement, fetchBuyerInvoices, fetchBuyerPOs,  fetchMaterialsData, fetchBuyerQuotes, setInitialLoad, updateSearchParams, fetchDispatchNotes } from '../../../services/redux/reducers/buyerDashboard/buyerDashboardRequirement';
import { fetchMaterialBrands, fetchMaterialCategories, fetchOrderTypesData } from '../../../services/redux/reducers/commonThunk';
import BuyerInvoiceModal from './Components/BuyerInvoiceModal';
import { Dialog } from 'primereact/dialog';
import ReqDetailsModal from './Components/ReqItemsDetails';
import { DATE_TIME_FORMAT } from '../../../constants';


function Requirement(){

    const [visibleQuotes, setVisibleQuotes] = useState(false)
    const [visibleBuyerpo, setVisibleBuyerpo] = useState(false)
    const [visibleBuyerInvoice, setVisibleBuyerInvoice] = useState(false)
    const [visibleReqDetails, setVisibleReqDetails] = useState(false)
    const [buyerReqDisplayProducts, setBuyerReqDisplayProducts] = useState([]);
    const [isSearchVisible, setIsSearchVisible] = useState(true)
    const [selectedReq, setSelectedReq] = useState({})
    
    const [isPageLoading, setIsPageLoading] = useState(false)

    const requirementActionMenu = useRef(null)
   
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    
    const isInitialLoad = useSelector(state => state.requirements.isInitialLoad)
    const buyerRequirementData = useSelector(state => state.requirementDashboard.buyerRequirementData)
    const buyerRequirementItemsData = useSelector(state => state.requirementDashboard.buyerRequirementItemsData)
    const materilProductsData = useSelector(state => state.requirementDashboard.materialProductsData)
    const isLoading = useSelector(state => state.requirementDashboard.isLoading)
    const paginationParams = useSelector(state => state.requirementDashboard.paginationParams)
    const searchParams = useSelector(state => state.requirementDashboard.searchParams)
    
    const buyerQuoteData = useSelector(state => state.requirementDashboard.buyerQuoteData)
    const buyerPOData = useSelector(state => state.requirementDashboard.buyerPOData)
    const sellerPOData = useSelector(state => state.requirementDashboard.sellerPOData)
    const buyerInvoiceData = useSelector(state => state.requirementDashboard.buyerInvoiceData)
    const dispatchNoteData = useSelector(state => state.requirementDashboard.dispatchNoteData)

    const buyerQuoteLoading = useSelector(state => state.requirementDashboard.buyerQuoteLoading)
    const buyerPOLoading = useSelector(state => state.requirementDashboard.buyerPOLoading)
    const buyerInvoiceLoading = useSelector(state => state.requirementDashboard.buyerInvoiceLoading)
    const dispatchNoteLoading = useSelector(state => state.requirementDashboard.dispatchNoteLoading)

    const orderTypes = useSelector(state => state.common.orderTypes)
    const userDetails = useSelector(state => state.userDetails)


    useEffect(() => {
        getIntialLoadData()
    }, [])

    const getIntialLoadData = () => {
        if(isInitialLoad){
            let toDate = new Date()
            toDate.setHours(23, 59, 0, 0)
            toDate = toDate.toISOString()

            let fromDate = new Date()
            fromDate.setDate(fromDate.getDate() - 30)
            fromDate.setHours(0, 0, 0, 0)
            fromDate = fromDate.toISOString()

            let branchIds = []
            let companyIds = []
            if(userDetails?.activeUserRoleDetails?.branchId){
                branchIds.push(userDetails?.activeUserRoleDetails?.branchId)
            } else {
                companyIds.push(userDetails?.activeUserRoleDetails?.companyId)
            }

            const updatedSearchParams = {
                ...searchParams,
                fromDate: fromDate,
                toDate: toDate
            }
    
            let requirementParams = { 
                ...updatedSearchParams,
                ...paginationParams,
                branchIds,
                companyIds,
                pageNo: 0,
                include: [ 
                    { model: "company", attributes: ["companyName"] }, 
                    { model: "kam", attributes: ["firstName", "lastName"] } ,
                    { model: "buyerCompanyBranch", attributes: ["branchName"] } ,
                    { model: "buyer", attributes: ["firstName", "lastName"] } 
                ]
            }

            const queryParams = new URLSearchParams(location.search)
            if (queryParams.get('docNo')) {
                requirementParams["searchBy"] = "docNo"
                requirementParams["searchText"] = queryParams.get('docNo')
                requirementParams['docNo'] = queryParams.get('docNo')
            }

            console.log("params", requirementParams)
            dispatch(updateSearchParams(updatedSearchParams))
            dispatch(fetchBuyerDashboardRequirement(requirementParams))
            dispatch(setInitialLoad(false))
        }
    }
    
    useEffect(() => {
        let buyerReqIds = buyerRequirementData?.map(eachBuyerRequirement => eachBuyerRequirement.buyerReqId)
        let data = {
            buyerReqIds: buyerReqIds
        }
       
        dispatch(fetchBuyerQuotes(data))
        dispatch(fetchBuyerPOs(data))
        dispatch(fetchDispatchNotes(data))
        dispatch(fetchBuyerInvoices(data))
        dispatch(fetchOrderTypesData())

    },[buyerRequirementData])

    useEffect(() => {
        if (buyerRequirementItemsData?.length > 0){
            let buyerReqItemIds = buyerRequirementItemsData?.map(eachBuyerRequirementItem => eachBuyerRequirementItem?.buyerReqItemId)
            let materialIdParams = {
                buyerReqItemsIds: buyerReqItemIds
            }
            dispatch(fetchMaterialsData(materialIdParams))
            dispatch(fetchMaterialBrands())
            dispatch(fetchMaterialCategories())
            dispatch(fetchOrderTypesData())
        }
    }, [buyerRequirementItemsData])

    const handlePageChange = async (e) => {
        let branchIds = []
        let companyIds = []
        if(userDetails?.activeUserRoleDetails?.branchId){
            branchIds.push(userDetails?.activeUserRoleDetails?.branchId)
        } else {
            companyIds.push(userDetails?.activeUserRoleDetails?.companyId)
        }
        let requirementParams = { 
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            branchIds,
            companyIds,
            getCount: false,
            ...searchParams
        }

        if (requirementParams.searchBy !== "all") {
            requirementParams[requirementParams.searchBy] = requirementParams.searchText.trim()
        }

        dispatch(fetchBuyerDashboardRequirement({...requirementParams, include: [ { model: "company", attributes: ["companyName"] }, { model: "kam", attributes: ["firstName", "lastName"] },  {model: "buyerCompanyBranch", attributes: ["branchName"]}, { model: "buyer", attributes: ["firstName", "lastName"] } ]}))
    }

    const quotesTemplate = (row)=>{
        const relatedBuyerQuotes = buyerQuoteData?.data?.buyerQuotes?.filter(eachBuyerQuote => (eachBuyerQuote?.buyerReqId === row?.buyerReqId && eachBuyerQuote?.statusId === 1))
        return(
            <>
                {
                    buyerQuoteLoading ? 
                        <Button className='bg-green-300 border-green-300' label={relatedBuyerQuotes?.length > 0 ? relatedBuyerQuotes?.length : "0"} style={{width:"30px", height:"30px"}} rounded icon="pi pi-spin pi-spinner" disabled onClick={() => {setVisibleQuotes(true); setSelectedReq({...row})}}/> :
                        <Button className='bg-green-300 border-green-300' label={relatedBuyerQuotes?.length > 0 ? relatedBuyerQuotes?.length: "0"} style={{width:"30px", height:"30px"}} rounded onClick={() => {setVisibleQuotes(true); setSelectedReq({...row})}}/> 
                }
            </>
        )
    }

    const buyerPoTemplate = (row)=>{
        const relatedBuyerPOs = buyerPOData?.buyerPOs?.filter(eachBuyerPO => eachBuyerPO?.buyerReqId === row?.buyerReqId)
        const activeBuyerPOs = relatedBuyerPOs?.filter(eachBuyerPO => [3, 4].includes(eachBuyerPO.statusId))

        return(
            <>
                {
                    buyerPOLoading ?
                        <Button className='bg-yellow-300 border-yellow-300' label={activeBuyerPOs?.length > 0 ? activeBuyerPOs?.length : "0"} style={{width:"30px",height:"30px"}} rounded icon="pi pi-spin pi-spinner" disabled onClick={() => {setVisibleBuyerpo(true); setSelectedReq({...row})}}/> :
                        <Button className='bg-yellow-300 border-yellow-300' label={activeBuyerPOs?.length > 0 ? activeBuyerPOs?.length : "0"} style={{width:"30px",height:"30px"}} rounded disabled={!relatedBuyerPOs?.length} onClick={() => {setVisibleBuyerpo(true); setSelectedReq({...row})}}/>
                }
            </>
        )
    }

    const buyerInvoiceTemplate = (row)=>{
        let relatedBuyerInvoiceItems = buyerInvoiceData?.data?.buyerInvoiceItems?.filter(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerReqId === row?.buyerReqId)
        let relatedBuyerInvoiceIds = relatedBuyerInvoiceItems?.map(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerInvoiceId)
        const relatedBuyerInvoices = buyerInvoiceData?.data?.buyerInvoice?.filter(eachBuyerInvoice => relatedBuyerInvoiceIds.includes(eachBuyerInvoice?.buyerInvoiceId))
        const activeBuyerInvoices = relatedBuyerInvoices?.filter(eachBuyerInvoice => eachBuyerInvoice?.statusId === 1)
        return(
            <>
                {
                    buyerInvoiceLoading ?
                        <Button className='bg-cyan-300 border-cyan-300' label={activeBuyerInvoices?.length > 0 ? activeBuyerInvoices?.length : "0"} style={{width:"30px",height:"30px"}} rounded icon="pi pi-spin pi-spinner" disabled onClick={() => {setVisibleBuyerInvoice(true); setSelectedReq({...row})}}/> :
                        <Button className='bg-cyan-300 border-cyan-300' label={activeBuyerInvoices?.length > 0 ? activeBuyerInvoices?.length : "0"} style={{width:"30px",height:"30px"}} rounded disabled={!relatedBuyerInvoices?.length} onClick={() => {setVisibleBuyerInvoice(true); setSelectedReq({...row})}}/>
                }
            </>
        )
    }

    const handleCopyClick = (docNo) => {
        if(docNo){
            navigator.clipboard.writeText(docNo)
            .then(() => {
                return dispatch(raiseToast({severity:'success', detail: "Copied!", life: 3000}))
            })
            .catch((error) => {
                return dispatch(raiseToast({severity:'error', detail: "Can't copy", life: 3000}))
            })
        }
    }

    const handleDocNoClick = (products) => {
        setBuyerReqDisplayProducts(products)
        setVisibleReqDetails(true)
    }

    const getDocNoBody = (row) => {
        const date = moment(row.createdAt).format(DATE_TIME_FORMAT)
        const relatedOrderType = orderTypes.find(eachOrderType => eachOrderType.orderTypeId === row.orderTypeId)
        const buyerReqId = row.buyerReqId
        let allProducts = []

        buyerRequirementItemsData?.filter((eachReqItem) => {
            if (eachReqItem.buyerReqId === buyerReqId) {
                materilProductsData.find((eachProduct) => {
                    if (eachProduct.buyerReqItemId === eachReqItem.buyerReqItemId) {
                        const relatedBuyerRateContractId = eachReqItem?.buyerRateContractId
                        const itemQty = eachReqItem?.qty
                        const relatedOrderTypeId = buyerRequirementData.find((req) => req.buyerReqId === buyerReqId);
                        const relatedOrderType = orderTypes.find((eachOrderType) =>eachOrderType.orderTypeId ===relatedOrderTypeId?.orderTypeId )
                        allProducts.push({ ...eachProduct, buyerRateContractId : relatedBuyerRateContractId , orderTypeId: relatedOrderTypeId?.orderTypeId, orderType : relatedOrderType?.orderType, createdAt: date, docNo: row.docNo, qty : itemQty });
                    }
                });
            }
        })
        
        return (
            <div className='req-no-container pl-2' style={{position: "relative"}}>
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row?.docNo ? 
                        <>
                            <p className='doc-no requirement-details-tooltip' style={{cursor : "pointer", color: "#0da487"}} onClick={() => handleDocNoClick(allProducts)}>{row?.docNo}</p>
                            <i className="pi pi-copy pl-1 doc-copy-icon" style={{cursor : "pointer", color: "#0da487"}} onClick={() => handleCopyClick(row.docNo)} ></i>
                        </>
                        : ""
                    } 
                </div>
                <p className='mr-4 date'>{date} {relatedOrderType.orderType[0]}</p>
                <Tooltip target=".requirement-details-tooltip" position='top'>
                    <span>View requirement details</span>
                </Tooltip>
            </div>
        )
    }

    const getUserBody = (row) => {
        let buyerName = ""
        if(row["buyer.firstName"]){
            buyerName = row["buyer.firstName"]
        }
        if(row["buyer.lastName"]){
            buyerName += " " + row["buyer.lastName"]
        }

        let companyShortName = getCompanyShortName(row["company.companyName"])
        return (<p className='m-0'><span>{buyerName}</span><br /><span className='date'>{row["buyerCompanyBranch.branchName"]}</span> <br/></p>)
    }

    const getKamBody = (row) => {
        let kamName = ""
        if(row["kam.firstName"]){
            kamName = row["kam.firstName"]
        }
        if(row["kam.lastName"]){
            kamName += " " + row["kam.lastName"]
        }

        if(kamName){
            return (<div>
                <p className='m-0'><PMUserName userName={kamName} userId={row.createdBy}/></p>
                <p className=' m-0 date'>{row["pmCompanyBranch.branchName"]}</p>
            </div>)
        }
    }

    const getProductBody = (row) => {
        const buyerReqId = row.buyerReqId
        let productNamesListWithDuplicates = []
        let productNamesList = []
        
        buyerRequirementItemsData?.filter((eachReqItem) => {
            if(eachReqItem.buyerReqId === buyerReqId){
                materilProductsData.find((each) => {
                    if(each.buyerReqItemId === eachReqItem.buyerReqItemId){
                        const productName = each.productName
                        if(productNamesList.includes(productName)){
                            productNamesListWithDuplicates.push(productName)
                        }else{
                            productNamesList.push(productName)
                        }
                    }
                })
            }
        })

        if(productNamesList.length > 0 && productNamesListWithDuplicates.length > 0){
            const totalProductNamesStr = `${productNamesList.join(", ")}, ${productNamesListWithDuplicates.join(", ")}`
            const displayProductNameStr = `${productNamesList.slice(0,6).join(", ")} & ${productNamesList.slice(6).length+productNamesListWithDuplicates.length} more items`

            return (
                <>
                    <Tooltip target={`.custom-tool-tip-${buyerReqId}`} position="top" autoHide className='post-req-tooltip' style={{ maxWidth: "600px"}} >
                        <p className='m-0'>{totalProductNamesStr}</p>
                    </Tooltip>
                    <p className={`custom-tool-tip-${buyerReqId}`} style={{ margin: "0px"}} >
                    {displayProductNameStr}
                    </p>
                </>
            )
        }
        return (productNamesList.length > 6 ? `${productNamesList.slice(0, 6).join(", ")} & ${productNamesList.slice(6).length} more items` : productNamesList.join(", "))
    }

    const tableColumns = [
        {
            header: 'Req. No.',
            // field: 'docNo',
            body: getDocNoBody,
            
        },
        {
            header: 'ProcMart KAM',
            // field: 'createdBy',
            body: getKamBody,
            
        },
        {
            header: 'Products',
            // field: 'productName',
            body: getProductBody,
            style: { width: "350px"}
        },
        {
            header: 'User Name',
            field: 'company.companyName',
            body: getUserBody,
            style: { maxWidth:"150px"}
        },
        {
            header: 'Quotes',
            field: 'Quotes',
            body: quotesTemplate,
            style:{ width: "70px"}
        },
        {
            header: 'Buyer PO',
            field: 'Buyer PO',
            body: buyerPoTemplate,
            style:{ width: "80px"}
        },
        {
            header: 'Buyer Invoice',
            field: 'Buyer PO',
            body: buyerInvoiceTemplate,
            style:{ width: "80px"}
        },
    ]

    const actionButtons = [
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => setIsSearchVisible(!isSearchVisible),
            // className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return(
        <div className="buyer-requirement-layout flex flex-column buyer-portal-buyer-dashboard" style={{backgroundColor:"white"}}>
            <div className="flex justify-content-between">
                <h3 className="m-2" style={{borderBottom: "2px solid #0da487"}} >Requirements</h3> 
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <Button icon="pi pi-shopping-cart" className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Post Requirement" onClick={() => {navigate(`/postrequirement`)}} /> */}
                    {/* <Button icon="pi pi-filter" className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Filter" onClick={() => {setIsSearchVisible(!isSearchVisible)}} /> */}
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row' style={{}}>
                <div className="buyer-portal-requirement-table" style={{ order: "1", width: isSearchVisible ? "82%" : "100%" }}>
                    <div className='mb-0'>
                        <div className="flex-grow-1" >
                            <Table 
                                lazy 
                                page={paginationParams.pageNo} 
                                onPageChange={(e)=> handlePageChange(e)} 
                                totalRecords={paginationParams.totalRecords} 
                                tableColumns={tableColumns} 
                                data={buyerRequirementData} 
                                rows={paginationParams.recordsPerPage} 
                                scrollable={"true"}
                                // scrollHeight="550px"
                                paginator
                                excessPagesFound= {paginationParams.excessPagesFound}
                                loading={isLoading} 
                                className="table all-package order-table theme-table dataTable no-footer"
                            />
                        </div>
                     </div>
                </div>

                {isSearchVisible &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px", borderLeft: "1px solid rgb(221, 221, 221)", marginLeft: "20px"}} className="justify-content-end" >
                        <SearchBar />
                    </div> 
                }
            </div>

            <Dialog header="REQUIREMENT DETAILS" visible={visibleReqDetails} style={{ width: '90vw', minHeight: "50vh", }}  onHide={() => setVisibleReqDetails(false)}>
                <ReqDetailsModal buyerReqDisplayProducts={buyerReqDisplayProducts} />
            </Dialog>

            <QuotationModal selectedReq={selectedReq} setIsPageLoading={setIsPageLoading} buyerQuotes={buyerQuoteData?.data?.buyerQuotes} buyerQuoteItems={buyerQuoteData?.data?.buyerQuoteItems} materialDetails={materilProductsData} buyerPOs={buyerPOData?.buyerPOs} visibleQuotes={visibleQuotes} setVisibleQuotes={setVisibleQuotes} />
            
            <BuyerPoModal selectedReq={selectedReq} buyerQuotes={buyerQuoteData?.data?.buyerQuotes} buyerPOs={buyerPOData?.buyerPOs} buyerPOItems={buyerPOData?.buyerPOItems} materialDetails={materilProductsData} sellerPOs={sellerPOData?.data?.sellerPOs} visibleBuyerpo={visibleBuyerpo} setVisibleBuyerpo={setVisibleBuyerpo} />

            <BuyerInvoiceModal 
                selectedReq={selectedReq} 
                buyerPOs={buyerPOData?.buyerPOs}
                dispatchNotes={dispatchNoteData?.data?.dispatchNotes} 
                dispatchNoteItems={dispatchNoteData?.data?.dispatchNoteItems} 
                invoiceDispatchMaps={dispatchNoteData?.data?.invoiceDispatchMaps} 
                buyerInvoices={buyerInvoiceData?.data?.buyerInvoice} 
                buyerInvoiceItems={buyerInvoiceData?.data?.buyerInvoiceItems} 
                materialDetails={materilProductsData} 
                visibleBuyerInvoice={visibleBuyerInvoice} 
                setVisibleBuyerInvoice={setVisibleBuyerInvoice} 
                setIsPageLoading={setIsPageLoading}
            />

            <Loading visible={isPageLoading} />
            
        </div>

    )
}

export default Requirement;
